import { post, ENDPOINTS } from "../../../services/shopify";

const verifyGatewayCredentials = (values, shop, gatewayName, token) =>
  post({
    endpoint: ENDPOINTS.CREDENTIALS,
    token,
    gatewayName,
    body: {
      shop,
      ...values,
    },
  });
  
export default verifyGatewayCredentials;
